import React, { useEffect, useState } from "react";
import { History, Plus, Minus } from "lucide-react";

const premiumStyles = {
  container: {
    backgroundColor: "#1e293b",
    borderRadius: "20px",
    padding: "32px",
    boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.3)",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    maxWidth: 600,
    margin: "0 auto",
  },
  title: {
    color: "#f8fafc",
    fontWeight: 700,
    fontSize: "1.5rem",
    marginBottom: "24px",
    display: "flex",
    alignItems: "center",
    gap: "10px"
  },
  list: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  listItem: {
    backgroundColor: "#0f172a",
    borderRadius: "16px",
    border: "1px solid rgba(255, 255, 255, 0.05)",
    padding: "20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  details: {
    color: "#cbd5e1",
    fontSize: "0.95rem"
  },
  strong: {
    fontWeight: "600",
    color: "#f8fafc",
    fontSize: "1.05rem",
    marginBottom: "4px"
  },
  timestamp: {
    fontSize: "0.85rem",
    color: "#64748b",
    marginTop: "8px",
  },
  badgePositive: {
    backgroundColor: "rgba(16, 185, 129, 0.15)",
    color: "#10b981",
    borderRadius: "12px",
    padding: "8px 14px",
    fontWeight: 700,
    minWidth: "60px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    fontSize: "1.1rem"
  },
  badgeNegative: {
    backgroundColor: "rgba(239, 68, 68, 0.15)",
    color: "#ef4444",
    borderRadius: "12px",
    padding: "8px 14px",
    fontWeight: 700,
    minWidth: "60px",
    textAlign: "center",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    fontSize: "1.1rem"
  },
  message: {
    color: "#94a3b8",
    fontSize: "1rem",
    textAlign: "center",
    padding: "40px 20px",
    fontStyle: "italic"
  },
};

export default function PointsHistory({ memberId }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if(!memberId) return;
    fetch(`https://prdp-api.suport-949.workers.dev/api/puncte-log/${memberId}`, {
      headers: { Authorization: "Bearer unwantedtok" },
    })
      .then((res) => res.json())
      .then((data) => {
        const sortedData = data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setLogs(sortedData);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, [memberId]);

  if (loading) return <div style={premiumStyles.message}>Se încarcă istoricul punctelor...</div>;
  if (!logs.length) return <div style={premiumStyles.message}>Nu există istoric de puncte momentan.</div>;

  return (
    <div style={premiumStyles.container}>
      <h4 style={premiumStyles.title}>
        <History color="#fbbf24" size={28} /> Istoric complet
      </h4>
      <ul style={premiumStyles.list}>
        {logs.map(({ id, action_type, puncte, details, timestamp }) => (
          <li key={id} style={premiumStyles.listItem}>
            <div style={{ flex: 1, paddingRight: "16px" }}>
              <div style={premiumStyles.strong}>{action_type}</div>
              <div style={premiumStyles.details}>{details || "Atribuire standard"}</div>
              <div style={premiumStyles.timestamp}>
                {new Date(timestamp).toLocaleString("ro-RO", { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute:'2-digit' })}
              </div>
            </div>
            
            <div style={puncte > 0 ? premiumStyles.badgePositive : premiumStyles.badgeNegative}>
              {puncte > 0 ? <Plus size={16} strokeWidth={3} /> : <Minus size={16} strokeWidth={3} />}
              {Math.abs(puncte)}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
